<template>
  <div style="min-height: 92vh">
    <div v-show="!showCreator">
      <ModuleHeader>Concierges</ModuleHeader>
      <uv-data-table
        :config="config"
        :data="Concierges"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>

    <modal v-model="showModal" :showFooter="false" title="Concierges">
      <ConciergesForm
        :edit="editMode"
        @toggle="toggleModal"
        @reload="getConcierges"
        @successData="successData"
        :key="formIndex"
        :dataEdit="editData"
      />
    </modal>
  </div>
</template>

<style></style>

<script>
import moment from "moment";
import modal from "../MainComponents/modal.vue";
import uvDataTable from "../MainComponents/DataTable.vue";
import ConciergesForm from "./ConciergesForm.vue";

export default {
  name: "ConciergesCRUD",
  components: {
    modal,
    uvDataTable,
    ConciergesForm,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      showCreator: false,
      Concierges: [],
      editData: [],
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        allowExport: true,
        rawText: "Concierges",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addConcierge",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editConcierge",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteConcierge",
            require: true,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "nom",
          },
          {
            text: "Agencia",
            value: "htl",
            format: (row) => {
              if (row["htl"]) {
                return row["htl"].nm;
              }
            },
            canBeFiltered: true,
          },
          {
            text: "Comision",
            value: "cms",
            format: (row) => {
              if (row["cms"]) {
                if (row["cms"].tp == "%") {
                  return row["cms"].vl + "%";
                } else {
                  return row["cms"].vl.C + row["cms"].vl.M;
                }
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addConcierge") {
        this.formIndex++;
        this.editMode = false;
        this.editData = null;
        this.showModal = true;
      }
      if (buttonId == "editConcierge") {
        this.formIndex++;
        this.editMode = true;
        let Data = this.$pgsHelper.getById(
          this.Concierges,
          "id",
          idSelected[0]
        );

        this.editData = this.$pgsHelper.cloneObj(Data);

        this.showModal = true;
      }

      if (buttonId == "deleteConcierge") {
        this.deleteDoc(idSelected[0]);
      }
    },
    async successData(data, doAction) {
      await this.getConcierges();
      this.showModal = false;
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async deleteDoc(id) {
      let datos = {
        Id: id,
      };

      this.$swal({
        title: "¿Deseas eliminar al concierge?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Concierges-deleteConcierge", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal("Borrado correctamente", "", "success");
            this.getConcierges();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    async getConcierges() {
      this.Concierges = [];
      let concierge =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Concierge",
          []
        );

      if (concierge.exists()) {
        let result = Object.entries(concierge.val());
        result.forEach((usu) => {
          let conciergeData = { id: usu[0], ...usu[1] };
          if (!conciergeData.dlat) {
            this.Concierges.push(conciergeData);
          }
        });
      } else {
        console.log("No existen usuarios");
      }
    },
  },
  computed: {},
  watch: {},
  async mounted() {
    await this.getConcierges();
  },
};
</script>
